import { CheckIcon } from "@heroicons/react/24/outline";

export function CompletionCheck({ className, color = "bg-green-500", size = 5 }: { className?: string, color?: string, size?: number }) {
    return (
        <div className={`w-${size + 2} h-${size + 2} flex items-center justify-center rounded-full shadow-lg ${color} ${className}`}><CheckIcon className={`w-${size} h-${size} text-white dark:text-gray-200`} /></div>
    );
}

export default CompletionCheck;